import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { left_arrow, no_image, tub } from "../../assets/imgs";
import CancelIcon from "@mui/icons-material/Cancel";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import { useAmenitiesListMutation, useLazyAmenitiesDropQuery, useLazyPropertiesViewQuery, useLazyPropertyImageDeleteQuery, useLazyRoomCategoriesDropQuery, useMinimumAgeMutation, usePropertiesRequestApproveMutation, usePropertyRoomDetailsAddMutation } from "../../screens/redux/api/api";
import { toast } from "react-toastify";
import { configJodit } from "../../screens/redux/api/Constants";
import SelectBoxImg from "../../components/SelectBoxImg";
import { Spinner } from "react-bootstrap";

const ApproveRoomsTab = ({ data, setTabs }) => {
    const navigate = useNavigate();
    const editor = useRef([]);
    const imgRef = useRef([]);
    const [image, setImage] = useState("");
    const [popup, setPopup] = useState(false);
    const [roomCat, setRoomCat] = useState([]);
    const prop_id = data?.data?.id;
    const [loading, setLoading] = useState(false);
    const [amiList, setAmiList] = useState([]);
    const [draggedItem, setDraggedItem] = useState(null);
    const [rejPopup, setRejPopup] = useState(false)
    const [reason, setReason] = useState('')
    const [edit, setEdit] = useState(false);
    const [selectedRoomCats, setSelectedRoomCats] = useState([]);

    // RTK Queries
    const [minimumAgeListApi] = useLazyRoomCategoriesDropQuery();
    const [aminitiesListApi] = useLazyAmenitiesDropQuery();
    const [roomsAddApi] = usePropertyRoomDetailsAddMutation();
    const [propertyView] = useLazyPropertiesViewQuery();
    const [propertyApproveApi] = usePropertiesRequestApproveMutation();
    const [propertyImageDelete] = useLazyPropertyImageDeleteQuery()
    const status = data?.data?.verification_status
    console.log('status', status)



    const joditConfig = useMemo(() => ({
        readonly: !edit,
        ...configJodit
    }), [edit]);
    // const id = data?.data?.id;

    // Initialize rooms state with existing data or empty template
    const [newRooms, setNewRooms] = useState(() => {
        if (data?.data?.rooms && data.data.rooms.length > 0) {
            return data.data.rooms.map(room => ({
                id: room.id,
                room_category: room.room_category_id.toString(),
                no_of_room: room.no_of_rooms.toString(),
                amenities: room.amenities.map(amenity => ({
                    id: amenity.id,
                    name: amenity.name,
                    image_url: amenity.icon || tub
                })),
                price_per_day: {
                    monday: room.prices?.mon_price?.toString() || "",
                    tuesday: room.prices?.tue_price?.toString() || "",
                    wednesday: room.prices?.wed_price?.toString() || "",
                    thursday: room.prices?.thu_price?.toString() || "",
                    friday: room.prices?.fri_price?.toString() || "",
                    saturday: room.prices?.sat_price?.toString() || "",
                    sunday: room.prices?.sun_price?.toString() || "",
                },
                total_person_count: room.prices?.total_persons?.toString() || "",
                extra_person_count: room.prices?.additional_persons?.toString() || "",
                extra_charges_per_person: room.prices?.extra_charge_per_person?.toString() || "",
                description: room.description || "",
                images: room.images.map(img => img.image) || [],
                imgId: room.images.map(img => img.id) || [],
            }));
        }
        return [
            {
                room_category: "",
                no_of_room: "",
                amenities: [],
                price_per_day: {
                    monday: "",
                    tuesday: "",
                    wednesday: "",
                    thursday: "",
                    friday: "",
                    saturday: "",
                    sunday: "",
                },
                total_person_count: "",
                extra_person_count: "",
                extra_charges_per_person: "",
                description: "",
                images: [],
                imgId: [],
            },
        ];
    });

    console.log("newrooms", newRooms);


    // Helper function to convert base64 to Blob
    const base64ToBlob = (base64) => {
        const byteString = atob(base64.split(',')[1]);
        const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    // Helper function to fetch URL and convert to Blob
    const urlToBlob = async (url) => {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch image from ${url}`);
        return await response.blob();
    };


    const addRoomsFunc = async () => {
        // Validate at least one room exists
        if (newRooms.length === 0) {
            toast.error('Please add at least one room');
            return;
        }

        // Validate each room
        for (const [roomIndex, room] of newRooms.entries()) {
            // Validate room category
            if (!room.room_category) {
                toast.error(`Room ${roomIndex + 1}: Please select a room category`);
                return;
            }

            // Validate number of rooms
            if (!room.no_of_room || isNaN(room.no_of_room) || room.no_of_room <= 0) {
                toast.error(`Room ${roomIndex + 1}: Please enter a valid number of rooms (must be at least 1)`);
                return;
            }

            // Validate at least one amenity is selected
            if (room.amenities.length === 0) {
                toast.error(`Room ${roomIndex + 1}: Please select at least one amenity`);
                return;
            }

            // Validate description
            if (!room.description || room.description.trim() === '') {
                toast.error(`Room ${roomIndex + 1}: Description is required`);
                return;
            }

            // Validate prices
            const requiredPriceFields = [
                'monday', 'tuesday', 'wednesday', 'thursday',
                'friday', 'saturday', 'sunday'
            ];

            for (const day of requiredPriceFields) {
                const price = room.price_per_day[day];
                if (!price || isNaN(price) || price < 0) {
                    toast.error(`Room ${roomIndex + 1}: Please enter a valid price for ${day}`);
                    return;
                }
            }

            // Validate person counts
            if (!room.total_person_count || isNaN(room.total_person_count) || room.total_person_count <= 0) {
                toast.error(`Room ${roomIndex + 1}: Please enter a valid total person count`);
                return;
            }

            if (room.extra_person_count && (isNaN(room.extra_person_count) || room.extra_person_count < 0)) {
                toast.error(`Room ${roomIndex + 1}: Please enter a valid extra person count`);
                return;
            }

            if (room.extra_charges_per_person && (isNaN(room.extra_charges_per_person) || room.extra_charges_per_person < 0)) {
                toast.error(`Room ${roomIndex + 1}: Please enter valid extra charges per person`);
                return;
            }

            // // Validate images
            // if (room.images.length === 0) {
            //     toast.error(`Room ${roomIndex + 1}: Please upload at least one image`);
            //     return;
            // }

            // Validate image file types (for new uploads)
            for (const image of room.images) {
                if (image instanceof File) {
                    const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
                    if (!validTypes.includes(image.type)) {
                        toast.error(`Room ${roomIndex + 1}: Invalid image format (only JPG, PNG, WEBP allowed)`);
                        return;
                    }

                    // Validate image size (e.g., 5MB max)
                    const maxSize = 5 * 1024 * 1024; // 5MB
                    if (image.size > maxSize) {
                        toast.error(`Room ${roomIndex + 1}: Image size too large (max 5MB)`);
                        return;
                    }
                }
            }
        }

        setLoading(true);
        try {
            // Validate at least one room exists
            if (newRooms.length === 0) {
                toast.error('Please add at least one room');
                return;
            }

            // Validate each room
            for (const [roomIndex, room] of newRooms.entries()) {
                if (!room.room_category) {
                    toast.error(`Room ${roomIndex + 1}: Please select a room category`);
                    return;
                }
                if (!room.no_of_room || isNaN(room.no_of_room) || room.no_of_room <= 0) {
                    toast.error(`Room ${roomIndex + 1}: Please enter a valid number of rooms`);
                    return;
                }
                if (room.amenities.length === 0) {
                    toast.error(`Room ${roomIndex + 1}: Please select at least one amenity`);
                    return;
                }
            }

            setLoading(true);
            const formData = new FormData();
            formData.append('property_id', prop_id.toString());

            // Helper function to convert image to blob
            const getImageBlob = async (image) => {
                if (image instanceof File) return image;
                if (typeof image === 'string') {
                    if (image.startsWith('data:')) {
                        // Base64 image
                        const byteString = atob(image.split(',')[1]);
                        const mimeType = image.split(',')[0].split(':')[1].split(';')[0];
                        const ab = new ArrayBuffer(byteString.length);
                        const ia = new Uint8Array(ab);
                        for (let i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i);
                        }
                        return new Blob([ab], { type: mimeType });
                    } else {
                        // URL image
                        const response = await fetch(image);
                        if (!response.ok) throw new Error('Failed to fetch image');
                        return await response.blob();
                    }
                }
                throw new Error('Unsupported image format');
            };

            // Process each room
            for (const [roomIndex, room] of newRooms.entries()) {
                // Basic room info
                if (room.id) {
                    formData.append(`rooms[${roomIndex}][room_id]`, room.id.toString());
                }
                formData.append(`rooms[${roomIndex}][room_category_id]`, room.room_category.toString());
                formData.append(`rooms[${roomIndex}][no_of_rooms]`, room.no_of_room.toString());

                // Amenities
                room.amenities.forEach((amenity, amenityIndex) => {
                    formData.append(`rooms[${roomIndex}][amenity_ids][${amenityIndex}]`, amenity.id.toString());
                });

                // Pricing
                formData.append(`rooms[${roomIndex}][prices][mon_price]`, room.price_per_day.monday || "0");
                formData.append(`rooms[${roomIndex}][prices][tue_price]`, room.price_per_day.tuesday || "0");
                formData.append(`rooms[${roomIndex}][prices][wed_price]`, room.price_per_day.wednesday || "0");
                formData.append(`rooms[${roomIndex}][prices][thu_price]`, room.price_per_day.thursday || "0");
                formData.append(`rooms[${roomIndex}][prices][fri_price]`, room.price_per_day.friday || "0");
                formData.append(`rooms[${roomIndex}][prices][sat_price]`, room.price_per_day.saturday || "0");
                formData.append(`rooms[${roomIndex}][prices][sun_price]`, room.price_per_day.sunday || "0");
                formData.append(`rooms[${roomIndex}][prices][total_persons]`, room.total_person_count || "0");
                formData.append(`rooms[${roomIndex}][prices][additional_persons]`, room.extra_person_count || "0");
                formData.append(`rooms[${roomIndex}][prices][extra_charge_per_person]`, room.extra_charges_per_person || "0");

                // Description
                formData.append(`rooms[${roomIndex}][description]`, room.description || "");

                // Process images
                for (const [imageIndex, image] of room.images.entries()) {
                    try {
                        const blob = await getImageBlob(image);
                        const filename = image instanceof File ? image.name : `image_${imageIndex}.jpg`;

                        formData.append(`rooms[${roomIndex}][property_images][${imageIndex}][position]`, (imageIndex + 1).toString());
                        formData.append(`rooms[${roomIndex}][property_images][${imageIndex}][image]`, blob, filename);
                    } catch (error) {
                        console.error(`Error processing image ${imageIndex} for room ${roomIndex}:`, error);
                        // Fallback - send URL if conversion fails
                        if (typeof image === 'string') {
                            formData.append(`rooms[${roomIndex}][existing_images][${imageIndex}]`, image);
                        }
                    }
                }
            }

            const res = await roomsAddApi(formData).unwrap();
            toast.success(res?.message || "Rooms updated successfully!");
        } catch (err) {
            console.error('API Error:', err);
            toast.error(err?.data?.message || err?.message || "Failed to update rooms");
        } finally {
            setLoading(false);
        }
    };

    const getAgeList = (type) => {
        let formdata = new FormData();
        formdata.append('type', type);
        minimumAgeListApi(formdata)
            .unwrap()
            .then((res) => {
                setRoomCat(res?.data || []);
            }).catch((err) => {
                console.log('err', err);
                toast.error("Failed to load room categories");
            });
    };

    const getAminitiesList = () => {
        let formdata = new FormData();
        formdata.append('pagination', 0);
        aminitiesListApi(formdata)
            .unwrap()
            .then((res) => {
                setAmiList(res?.data || []);
            }).catch((err) => {
                console.error('err-ami', err);
                toast.error("Failed to load amenities");
            });
    };

    const getRooms = (id) => {
        propertyView(id)
            .unwrap()
            .then((res) => {
                if (res?.data?.rooms && res.data.rooms.length > 0) {
                    const mappedRooms = res.data.rooms.map(room => ({
                        id: room.id,
                        room_category: room.room_category_id.toString(),
                        no_of_room: room.no_of_rooms.toString(),
                        amenities: room.amenities.map(amenity => ({
                            id: amenity.id,
                            name: amenity.name,
                            image: amenity.image || tub
                        })),
                        price_per_day: {
                            monday: room.prices?.mon_price,
                            tuesday: room.prices?.tue_price?.toString(),
                            wednesday: room.prices?.wed_price?.toString(),
                            thursday: room.prices?.thu_price?.toString(),
                            friday: room.prices?.fri_price?.toString(),
                            saturday: room.prices?.sat_price?.toString(),
                            sunday: room.prices?.sun_price?.toString(),
                        },
                        total_person_count: room.prices?.total_persons?.toString() || "",
                        extra_person_count: room.prices?.additional_persons?.toString() || "",
                        extra_charges_per_person: room.prices?.extra_charge_per_person?.toString() || "",
                        description: room.description || "",
                        images: room.images.map(img => img.image) || [],
                        imgId: room.images.map(img => img.id) || []
                    }));
                    setNewRooms(mappedRooms);
                }
            }).catch((err) => {
                console.log('err', err);
                toast.error("Failed to load room details");
            });
    };





    useEffect(() => {
        getAgeList(1);
        getAminitiesList();
        if (prop_id) {
            getRooms(prop_id);
        }
    }, [prop_id]);

    const showImgPopup = (item) => {
        setImage(item);
        setPopup(true);
    };

    const removeAmenities = (ind, inds) => {
        setNewRooms(prevRooms => {
            const updatedRooms = [...prevRooms];
            const updatedAmenities = [...updatedRooms[ind].amenities];
            updatedAmenities.splice(inds, 1);
            updatedRooms[ind] = {
                ...updatedRooms[ind],
                amenities: updatedAmenities
            };
            return updatedRooms;
        });
    };

    const handleImageDelete = (id) => {
        propertyImageDelete(id)
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    toast.success(res?.message)
                }
            }).catch((err) => {
                toast.error(err?.message)
            })
    }

    const newRoomRemoveImage = (ind, indImg, item) => {
        const imgId = item?.[ind];
        console.log('imgId', imgId);
        handleImageDelete(imgId)
        setNewRooms(prevRooms => {
            const updatedRooms = [...prevRooms];
            const updatedImages = [...updatedRooms[ind].images];
            updatedImages.splice(indImg, 1);
            updatedRooms[ind] = {
                ...updatedRooms[ind],
                images: updatedImages
            };
            return updatedRooms;
        });
    };

    const handleChange = (event, ind, type, type_2) => {
        setNewRooms(prevRooms => {
            const updatedRooms = [...prevRooms];
            const updatedRoom = { ...updatedRooms[ind] };

            if (type_2) {
                updatedRoom.price_per_day = {
                    ...updatedRoom.price_per_day,
                    [type_2]: event
                };
            } else {
                if (type === "images") {
                    const files = event.target.files;
                    if (files) {
                        const filesArray = Array.from(files);
                        if (updatedRoom.images.length + filesArray.length > 10) {
                            toast.error("You can only upload a maximum of 10 images.");
                            return prevRooms;
                        }
                        updatedRoom[type] = [...updatedRoom[type], ...filesArray];
                    }
                } else {
                    updatedRoom[type] = event;
                }
            }

            updatedRooms[ind] = updatedRoom;
            return updatedRooms;
        });
    };

    const handleDragStart = (e, roomIndex, imageIndex) => {
        setDraggedItem({ roomIndex, imageIndex });
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/html", e.currentTarget);
    };

    const handleDragOver = (e, roomIndex, imageIndex) => {
        e.preventDefault();
        if (!draggedItem || (draggedItem.roomIndex === roomIndex && draggedItem.imageIndex === imageIndex)) {
            return;
        }

        const newIndex = imageIndex;
        const oldIndex = draggedItem.imageIndex;

        if (newIndex === oldIndex) return;

        setNewRooms(prevRooms => {
            const updatedRooms = [...prevRooms];
            const room = { ...updatedRooms[roomIndex] };
            const images = [...room.images];

            const [removed] = images.splice(oldIndex, 1);
            images.splice(newIndex, 0, removed);

            updatedRooms[roomIndex] = {
                ...room,
                images: images
            };

            setDraggedItem({
                roomIndex,
                imageIndex: newIndex
            });

            return updatedRooms;
        });
    };

    const handleDrop = (e, roomIndex, imageIndex) => {
        e.preventDefault();
        setDraggedItem(null);
    };

    const handleDragEnd = () => {
        setDraggedItem(null);
    };

    const addNewRoom = () => {
        setNewRooms(prevRooms => [
            ...prevRooms,
            {
                room_category: "",
                no_of_room: "",
                amenities: [],
                price_per_day: {
                    monday: "",
                    tuesday: "",
                    wednesday: "",
                    thursday: "",
                    friday: "",
                    saturday: "",
                    sunday: "",
                },
                total_person_count: "",
                extra_person_count: "",
                extra_charges_per_person: "",
                description: "",
                images: [],
            }
        ]);
    };

    const removeRooms = (ind) => {
        setNewRooms(prevRooms => {
            const updatedRooms = [...prevRooms];
            updatedRooms.splice(ind, 1);
            return updatedRooms;
        });
    };


    const handleReject = (id) => {
        setLoading(true)
        let formdata = new FormData()
        formdata.append('approval_status', 0);
        formdata.append('verification_type', 1)
        formdata.append('status', 3)
        formdata.append('resaon', reason)
        propertyApproveApi({ id: id, payload: formdata })
            .unwrap()
            .then((res) => {
                console.log(res)
                if (res?.status == 'success') {
                    toast.success(res?.message)
                    navigate('/property')
                }
            }).catch((err) => {
                console.log(err)
                toast.error(err?.message)
            }).finally(() => {
                setLoading(false)
            })
    }

    const handleApprove = (id) => {
        setLoading(true)
        let formdata = new FormData()
        formdata.append('approval_status', 1);
        formdata.append('verification_type', 1)
        formdata.append('status', 2)
        propertyApproveApi({ id: id, payload: formdata })
            .unwrap()
            .then((res) => {
                console.log(res)
                if (res?.status == 'success') {
                    toast.success(res?.message)
                    navigate('/property')
                }
            }).catch((err) => {
                console.log(err)
                toast.error(err?.message)
            }).finally(() => {
                setLoading(false)
            })

    }



    return (
        <div className="mt-2">
            <div className="d-flex ac-jb">
                <div className="d-flex ac-js pointer gap-2">
                    <img
                        src={left_arrow}
                        className="leftArrow mb-3 pointer"
                        onClick={() => setTabs(2)}
                        alt="Back"
                    />
                    <p
                        className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
                        onClick={() => setTabs(2)}
                    >
                        Back
                    </p>
                </div>
                <div onClick={() => setEdit(!edit)}>
                    {!edit ? (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                        style={{ cursor: 'pointer' }}
                    >
                        Edit
                    </p>) : (<p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
                        style={{ cursor: 'pointer' }}
                        onClick={() => getRooms(prop_id)}
                    >
                        cancel
                    </p>)}
                </div>
            </div>

            {newRooms?.map((item, ind) => (
                <div key={ind}>
                    {ind !== 0 && (
                        <div className="d-flex ac-je" onClick={() => removeRooms(ind)}>
                            <CancelIcon />
                        </div>)}

                    <div className="d-flex gap-5 mb-4">
                        <div className="col-md-5">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Room Category
                            </h4>
                            <select disabled={!edit}
                                className="input-pop ps-2 w-100"
                                value={item?.room_category}
                                onChange={(e) => {
                                    const newValue = Number(e.target.value);
                                    handleChange(newValue, ind, "room_category");
                                    setSelectedRoomCats(prev => [...prev, newValue]);
                                }}
                            >
                                <option value={""}>Select</option>
                                {roomCat
                                    ?.filter(cat => !selectedRoomCats.includes(cat.id) || cat.id === item?.room_category)
                                    ?.map((item, ind) => (
                                        <option key={Number(item?.id)} value={item?.id}>
                                            {item?.name}
                                        </option>
                                    ))
                                }
                            </select>

                        </div>
                        <div className="col-md-5">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                No of Rooms
                            </h4>
                            <input disabled={!edit}
                                type="text"
                                className="input-pop ps-2 w-100"
                                placeholder="No of Rooms"
                                value={item?.no_of_room}
                                onChange={(e) => handleChange(e.target.value, ind, "no_of_room")}
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        {edit && (
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Amenities
                            </h4>
                        )}
                        <div className="col-md-5">
                            <SelectBoxImg
                                array_list={amiList}
                                value_text={item?.amenities}
                                setvalue_text={() => { }}
                                setValidation={() => { }}
                                isMulti={true}
                                isTextArea={false}
                                types={"room"}
                                ind={ind}
                                key_name={"amenities"}
                                handleChange={handleChange}
                                edit={edit ? false : true}
                            />
                        </div>
                        <div className="d-flex align-items-center flex-wrap gap-4 mt-4">
                            {item?.amenities?.map((amenity, index) => {
                                console.log('item', item)

                                return (<div className="d-flex ac-jc gap-1 p-2 input-pop mb-3 position-relative" key={index}>

                                    <img src={amenity?.image_url ? amenity?.image_url : amenity?.image} className="tub-img" alt={amenity?.name} />
                                    <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                                        {/* {amenity?.name + amenity?.id} */}
                                        {amenity?.name}
                                    </p>
                                    {edit && (
                                        <div onClick={() => removeAmenities(ind, index)}>
                                            <CancelIcon
                                                className="red pointer"
                                                style={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    right: "-7px",
                                                    width: "15px",
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>)
                            })}
                        </div>
                    </div>

                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-4">
                        Pricing Per Day
                    </h4>
                    <div className="input-pop_box">
                        <table className="w-100">
                            <thead>
                                <tr className="text-center">
                                    {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(day => (
                                        <th key={day}>{day}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>

                                <tr className="text-center">
                                    {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map(day => (
                                        <td className="col-md-1" key={day}>
                                            <input disabled={!edit}
                                                className="input-pop w-80 mt-2 mb-2 text-center"
                                                placeholder={"amount"}
                                                value={item?.price_per_day?.[day]}
                                                onChange={(e) => handleChange(e.target.value, ind, "price_per_day", day)}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex flex-wrap ac-jb my-5">
                        <div className="col-md-3">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                                Total Person Count
                            </h4>
                            <input disabled={!edit}
                                type="text"
                                className="input-pop ps-2 w-100"
                                placeholder="Total Person Count"
                                value={item?.total_person_count}
                                onChange={(e) => handleChange(e.target.value, ind, "total_person_count")}
                            />
                        </div>
                        <div className="col-md-3">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                                Extra Person Count
                            </h4>
                            <input disabled={!edit}
                                type="text"
                                className="input-pop ps-2 w-100"
                                placeholder="Extra Person Count"
                                value={item?.extra_person_count}
                                onChange={(e) => handleChange(e.target.value, ind, "extra_person_count")}
                            />
                        </div>
                        <div className="col-md-3">
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                                Extra Charges Per Person
                            </h4>
                            <input disabled={!edit}
                                type="text"
                                className="input-pop ps-2 w-100"
                                placeholder="Extra Charges Per Person"
                                value={item?.extra_charges_per_person}
                                onChange={(e) => handleChange(e.target.value, ind, "extra_charges_per_person")}
                            />
                        </div>
                    </div>

                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
                        Description
                    </h4>
                    <JoditEditor config={joditConfig}
                        style={{ border: "1px solid #0C3A2D" }}
                        className="input-pop w-100"
                        ref={(el) => (editor.current[ind] = el)}
                        value={item?.description}
                        onBlur={(newContent) => handleChange(newContent, ind, "description")}
                    // config={configJodit}
                    />

                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
                        Choose Images (Max 10)
                    </h4>
                    <div className="d-flex ac-js gap-3 flex-wrap">
                        <div className="position-relative">
                            {edit && (
                                <button
                                    className="cust-btn recep-yes mt-3 mb-3"
                                    onClick={() => imgRef.current?.[ind]?.click()}
                                >
                                    Upload
                                </button>
                            )}
                            <input
                                type="file"
                                className="input-pop mt-2 w-100 d-none"
                                accept="image/*"
                                onChange={(e) => handleChange(e, ind, "images")}
                                multiple={true}
                                ref={(el) => (imgRef.current[ind] = el)}
                                disabled={item?.images?.length >= 10}
                            />
                            <div className="d-flex flex-wrap gap-2 mt-2">
                                {item?.images?.map((itemImg, indImg) => (
                                    <div
                                        key={indImg}
                                        className="position-relative"
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, ind, indImg)}
                                        onDragOver={(e) => handleDragOver(e, ind, indImg)}
                                        onDrop={(e) => handleDrop(e, ind, indImg)}
                                        onDragEnd={handleDragEnd}
                                        style={{
                                            opacity: draggedItem?.roomIndex === ind && draggedItem?.imageIndex === indImg ? 0.5 : 1,
                                            cursor: 'move'
                                        }}
                                    >
                                        <img
                                            src={itemImg?.name ? URL.createObjectURL(itemImg) : itemImg}
                                            style={{
                                                height: "100px",
                                                width: "100px",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => showImgPopup(itemImg)}
                                            alt=""
                                        />
                                        {edit && (
                                            <CancelIcon
                                                className="red pointer"
                                                style={{
                                                    position: "absolute",
                                                    top: "-5px",
                                                    right: "-7px",
                                                    width: "20px",
                                                }}
                                                onClick={() => newRoomRemoveImage(ind, indImg, item?.imgId)}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className="d-flex ac-je pointer" onClick={() => setPopup(false)}>
                            <CancelIcon />
                        </div>
                        <div style={{ width: "350px" }}>
                            <img
                                src={image?.name ? URL.createObjectURL(image) : image}
                                alt=""
                                className="w-100 mt-3"
                            />
                        </div>
                    </div>
                </div>
            )}
            {edit && (
                <div className="d-flex ac-jb mt-5">
                    <button
                        className="cust-btn btn_new text-nowrap f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                        onClick={addNewRoom}
                    >
                        Add Room
                    </button>
                    <button
                        className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                        onClick={addRoomsFunc}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="spinner-border spinner-border-sm"></div>
                        ) : (
                            "update"
                        )}
                    </button>
                </div>
            )}

            {rejPopup && (
                <div className="img-popup-design-new">
                    <div className="img-popup-new"
                        style={{
                            height: '250px'
                        }}
                    >
                        <div className='d-flex ac-jb' >
                            <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 sec">
                                Add Reason
                            </h4>
                            <button className='cust-btn' onClick={() => { setRejPopup(false); setReason(""); setLoading(false) }}>
                                <CancelIcon />
                            </button>
                        </div>
                        <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Reason
                        </h4>
                        <input type="text" value={reason} onChange={(e) => setReason(e.target.value)} className="input-pop ps-2 w-100" placeholder="Reason" />

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mt-3"
                                onClick={() => handleReject(prop_id)}
                            >
                                {loading ? (<div className="spinner-border spinner-border-sm"></div>) : "Submit"}

                            </button>
                        </div>
                    </div>
                </div>
            )}


            {status == 1 && (<div className="d-flex ac-jb mt-5">
                <button
                    className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                    onClick={() => setRejPopup(true)}
                >
                    Reject
                </button>
                <button
                    className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                    onClick={() => handleApprove(prop_id)}
                    disabled={loading}
                >
                    Approve
                </button>
            </div>)}
            {loading && (
                <div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
                    <Spinner animation="border" className="primary1" />
                </div>)}
        </div>
    );
};

export default memo(ApproveRoomsTab)